import { useReactiveVar } from "@apollo/client";
import { useEffect } from "react";
import { ConfirmReviewModal } from "./confirm-review-modal";
import { EditReviewModal } from "./edit-review-modal";
import { PostReviewModal } from "./post-review-modal";
import { isOpenReviewModalVar } from "~/components/stores/detail-product/store";
import { useQueryString } from "~/hooks/use-query-string";
import type { G_GetVideoQuery } from "~/lib/graphql";
import { useFetchUserReviewInfoLazyQuery, G_ReviewStatus } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";

type ReviewModalProps = {
  /** videoクエリを叩いて取得したデータ */
  videoData: G_GetVideoQuery["video"];
};

export const ReviewModal = (props: ReviewModalProps) => {
  const { videoData } = props;

  const isOpenReviewModal = useReactiveVar(isOpenReviewModalVar);
  const { isLoggedIn } = useAuth();
  const { season } = useQueryString();

  const [fetchUserReviewExec, { data: getUserReviewData }] = useFetchUserReviewInfoLazyQuery();

  const effectFetchUserReviewVideoExec = () => {
    const controller = new AbortController();

    (async () => {
      void fetchUserReviewExec({
        variables: {
          seasonId: season,
          isLoggedIn,
        },
      });
    })();

    return () => controller.abort();
  };

  useEffect(effectFetchUserReviewVideoExec, [isOpenReviewModal]);

  const { reviewer } = getUserReviewData?.user ?? {};

  if (reviewer !== undefined && reviewer !== null) {
    const { videoReviewStatus, nickname, id } = reviewer;

    if (videoReviewStatus === G_ReviewStatus.Confirming) return <ConfirmReviewModal />;

    /** MEMO : ニックネームが登録されている、かつ、レビュワーIDが登録されている、かつ、videoReviewStatus === PUBLISHEDの場合のみ、レビュー編集モーダルを開く */
    const isEditReviewModal =
      nickname !== undefined &&
      nickname !== null &&
      nickname !== "" &&
      id !== undefined &&
      id !== null &&
      id !== "" &&
      videoReviewStatus === G_ReviewStatus.Published;

    if (isEditReviewModal) {
      return <EditReviewModal videoData={videoData} reviewerId={id} />;
    }
  }

  return <PostReviewModal videoData={videoData} reviewer={reviewer} />;
};
